import { createSlice } from '@reduxjs/toolkit';

const initialState = { storedApplicant: null, aditionalState: null };

const SelectedApplicantSlice = createSlice({
  name: 'SelectedApplicant',
  initialState: {
    storedApplicant: null,
    aditionalState: null,
  },
  reducers: {
    setSelectedApplicant: (state, action) => {
      if (action.payload?.applicantDetails) {
        state.storedApplicant = action.payload.applicantDetails;
        state.aditionalState = null;
      }
      if (action.payload?.aditionalState) {
        state.aditionalState = action.payload.aditionalState;
      }
    },
    resetSelectedApplicant: () => initialState,
  },
});

export const { setSelectedApplicant, resetSelectedApplicant } =
  SelectedApplicantSlice.actions;
export default SelectedApplicantSlice.reducer;
